interface IBreadcrumbs {
  items: { title: string; href: string }[];
}

export const Breadcrumbs = ({ items }: IBreadcrumbs) => (
  <nav className="flex" aria-label="Breadcrumb">
    <ol className="inline-flex items-center space-x-1 md:space-x-2 rtl:space-x-reverse">
      {items.map((item, index) => (
        <li
          className={`${
            index === 0 ? 'ml-0' : ''
          } inline-flex items-center space-x-1 text-base text-accent-blue md:space-x-2 rtl:space-x-reverse`}
          key={item?.title + ' ' + index}
        >
          <a href={item?.href} className="inline-flex items-center text-sm font-medium">
            {item?.title}
          </a>
          <span>{index !== items.length - 1 && '>'}</span>
        </li>
      ))}
    </ol>
  </nav>
);

Breadcrumbs.displayName = 'Breadcrumbs';
